import { render, staticRenderFns } from "./PricingTopActionWrapper.vue?vue&type=template&id=13a89df8&scoped=true"
import script from "./PricingTopActionWrapper.vue?vue&type=script&lang=js"
export * from "./PricingTopActionWrapper.vue?vue&type=script&lang=js"
import style0 from "./PricingTopActionWrapper.vue?vue&type=style&index=0&id=13a89df8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a89df8",
  null
  
)

export default component.exports